import { MapPin } from 'lucide-react';
import { Reveal } from './Reveal';
import { cities } from '../data/site';

export const Coverage = () => (
  <section
    id="cobertura"
    data-testid="coverage-section"
    className="py-24 sm:py-32 bg-slate-50 border-y border-slate-200"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-start">
        <Reveal>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-600 mb-4">
            04 — Onde eu atuo
          </p>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight">
            Minas Gerais inteira,{' '}
            <span className="text-blue-600">na palma da mão.</span>
          </h2>
          <p className="mt-5 text-slate-500 text-sm sm:text-base leading-relaxed max-w-md">
            Atendimento presencial na região metropolitana de BH e digital para
            todo o estado. Seu veículo em outra cidade mineira? Eu resolvo da
            mesma forma.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 border border-blue-200 bg-blue-50 rounded-full px-4 py-2">
            <MapPin size={14} className="text-blue-600" />
            <span className="text-xs font-mono uppercase tracking-[0.18em] text-blue-600">
              Base: Rua de Pedestre, 151 · Jd. Teresópolis · Betim
            </span>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {cities.map((city, i) => (
            <Reveal key={city.name} delay={i * 0.06}>
              <div
                data-testid={`coverage-city-${city.name
                  .toLowerCase()
                  .replace(/\s+/g, '-')}`}
                className={`rounded-2xl border p-5 text-center transition-colors duration-300 ${
                  city.base
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-slate-200 bg-white hover:border-blue-300'
                }`}
              >
                <p
                  className={`font-display font-bold text-sm sm:text-base ${
                    city.base ? 'text-blue-700' : 'text-slate-700'
                  }`}
                >
                  {city.name}
                </p>
                {city.base && (
                  <p className="mt-1 text-[9px] font-mono uppercase tracking-[0.25em] text-blue-500">
                    Base
                  </p>
                )}
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.5} className="col-span-2 sm:col-span-4">
            <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-5 text-center">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                + todo o estado de Minas Gerais
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
